export enum EnvironmentType {
    Development,
    Staging,
    Main
}